import ActionCable from 'actioncable';
import * as ProgressBar from 'progressbar.js';
import 'jquery-toast-plugin'; // this also will import the jquery
import 'jquery-toast-plugin/dist/jquery.toast.min.css';
import plyr from 'plyr';
import ahoy from 'ahoy.js';
import shave from 'shave';
import anchorme from "anchorme";

let players = undefined;
let croppers = {};

window.App || (window.App = {});
window.App.cable = ActionCable.createConsumer();
window.App.progress = window.App.cable.subscriptions.create("ProgressChannel", {
  received: (data) => {
    $.toast({
      text:
      `<div class="progress-toast">
        Badge Progress!
        <br/>
        ${data.badge}
        ${data.description}
        <br/>
        Next: ${data.next}
        <br/>
        <div class="progress-bar" id="progress-bar-${data.id}"></div>
        <div class="progress-status">${data.completed ? "You rock!" : data.milestone - data.progress + " more to the next badge!" }</div>
        </div>`,
      hideAfter: 10000,
      showHideTransition: 'slide',
      position: 'top-right'
    });
    let progress = new ProgressBar.Line(`#progress-bar-${data.id}`, {
      color: '#FCB03C'
    });
    if (data.completed)
      progress.animate(1);
    else
      progress.animate(data.progress / data.milestone);
  }
})

function setEventHooks(player){
  player.count = 0;
  player.on("playing", function (event) {
    if (player.count == 0) {
      ahoy.track("video.watch", { url: player.source });
      player.count++;
    }
  });
  player.on("ended", function (event) {
    player.count = 0;
  })
}

$(document).ready(function(){
  $(".facebook-share").click(function() {
    FB.ui({
      method: 'share',
      mobile_iframe: true,
      href: $(this).data("url"),
    }, function(response){});
  })
  $(".facebook-send").click(function(){
    if($(this).data("is-mobile")) {
      window.open('fb-messenger://share?link=' + encodeURIComponent($(this).data("url")) + '&app_id=' + encodeURIComponent($(this).data("app-id")));
    } else {
      FB.ui({
        method: 'send',
        link: $(this).data("url")
      });
    }
  })
  function destroyPlyrs(){
    if (players) {
      players.forEach(function (player) {
        player.destroy();
      })
    }
  }
  function setupPlyr(){
    players = plyr.setup('#player', {
      quality: {
        default: 720,
      },
      ratio: '16:9',
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      youtube: {
        fs: 0,
        controls: 0
      }
    });
    if (players) {
      players.forEach(function (player) {
        setEventHooks(player);
      })
    }
  }

  function setupNewPlyrs(urls){
    let p = urls.map((url) => plyr.setup(document.querySelector(`[data-plyr-embed-id="${url}"]`)))
    if (players) {
      players.forEach(function (player) {
        setEventHooks(player);
      })
    }
  }

  function setupFeaturedVideoEvent(element) {
    $('html').animate({
      scrollTop: $(".segment").offset().top
    }, 500, function() {
      destroyPlyrs();
      $('#see-more').off('click');
      $("[data-plyr-provider='youtube']").attr({
        "data-plyr-embed-id": $(element).data("video-id"),
      });
      $("#main-video-title").html($(element).find(".video-title").text());
      $("#main-video-description").html($(element).find(".video-description").text());
      truncateDescription();
      setupPlyr();
    })
  }

  function anchorTruncatedDescription() {
    let truncatedDesc = $('#main-video-description').html();
    $('#main-video-description').html(anchorme(truncatedDesc))
  }

  function truncateDescription() {
    let descEl = $('#main-video-description'),
        descContent = anchorme(descEl.text()),
        seeMore = $('#see-more');

    if(descEl.length > 0) {
      shave('#main-video-description', 120);
      seeMore.text('See more');
      anchorTruncatedDescription();
      if($('#main-video-description .js-shave').length === 0) {
        seeMore.hide();
      } else {
        seeMore.show();
      }

      $('#see-more').click(function() {
        let hasShave = $('#main-video-description .js-shave');
        if(hasShave.length > 0) {
          descEl.html(descContent);
          seeMore.text('See less');
          return;
        }
        shave('#main-video-description', 120);
        anchorTruncatedDescription();
        seeMore.text('See more');
      })
    }
  }

  $(".video-tile").on("click", function(){
    destroyPlyrs();
    $("[data-plyr-provider='youtube']").attr({
      "data-plyr-embed-id": $(this).data("video-id"),
    });
    $("#main-video-title").html($(this).data("video-title"));
    $("#main-video-stats").html($(this).find(".video-stats").text());
    setupPlyr();
  })

  $(".featured-video-tile").on("click", function() {
    setupFeaturedVideoEvent(this);
  })

  setupPlyr();
  truncateDescription();

  // $(".article-item").on('mouseover', function(){
  //   $(this).find(".article-title a").css("border-bottom", "2px solid #f37766");
  // }).on('mouseout', function(){
  //   $(this).find(".article-title a").css("border-bottom", "none");
  // })

  $("#embed-modal").on('show.bs.modal', function(e){
    let source = $(e.relatedTarget).data('embed-url');
    let src = $(e.currentTarget).find('iframe').attr("src");
    if (src != source){
      $(e.currentTarget).find('iframe').attr("src", source);
    }
  });

  $('#favourite-album-button').click(function(){
    let item = $(this);
    if (item.data("favourited")) {
      item.data("favourited", false);
      $.ajax({
        url: item.data("unfavourite-url"),
        type: 'POST',
        success: data => {
          $("#favourite-heart").removeClass("favourited");
          $("#favourite-heart").addClass("not-favourited");
        },
        error: (xhr, status, err) => {
        }
      });
    } else {
      item.data("favourited", true);
      $.ajax({
        url: item.data("favourite-url"),
        type: 'POST',
        success: data => {
          $("#favourite-heart").removeClass("not-favourited");
          $("#favourite-heart").addClass("favourited");
        },
        error: (xhr, status, err) => {
        }
      });
    }
  });

  $('[data-toggle="tooltip"]').tooltip();

  $('.comment-comment-button').click(function(){
    $(this).parent().find('form').toggle();
  });
  $("#open-mobile-menu").click(function(){
    $(".mobile-menu-container").addClass("show")
  })
  $("#close-mobile-menu").click(function(){
    $(".mobile-menu-container").removeClass("show")
  })
  let tooltipTimeout
  $(".social-media-bar .copylink").click(function(event) {
    event.preventDefault();

    const el = document.createElement('textarea');
    el.value = $(this).data('url');
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999rem';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    $(this).tooltip({
      title: 'Copied',
      container: $(this),
      trigger: 'manual'
    });
    $(this).tooltip('show');

    clearTimeout(tooltipTimeout);
    tooltipTimeout = setTimeout((el) => {
      $(el).tooltip('hide');
    }, 1000, this);
  })

  $(".playlist-see-more").click(function(){
    let item = $(this);

    $.ajax({
      url: item.data("url"),
      data: {
        page: item.data("page")
      },
      type: 'GET',
      success: data => {
        let parent = item.parent().parent()[0]
        let nodes = parent.childNodes
        let newNodes = []

        data.results.forEach((result) => {
          let newNode = $.parseHTML(`<div class='col-md-4 col-12 featured-video-tile' data-video-id=${result.url}>
          <img class='video-thumbnail' src='${result.thumbnail}' >
          <h3 class='video-title'>${result.title}</h3>
          <div class='video-description d-none'>${result.description}</div>
          </div>`)[0]

          parent.insertBefore(newNode, nodes[nodes.length - 1])

          newNodes.push(newNode);
        })

        item.data("page", item.data("page") + 1)

        $(newNodes).click(function() {
          setupFeaturedVideoEvent(this)
        });

        $(parent).find(".js__see-more--loader").hide();

        if (!data.has_more)
          item.hide();
      },
      error: (xhr, status, err) => {
      }
    });
  })

  let classList = document.getElementsByTagName('body')[0].classList;
  if (classList.contains('submit')){
    let imageLoader = document.getElementById('album_image');
    imageLoader.addEventListener('change', function(e) { handleImage(e, 'image-preview', undefined, 1) }, false);
  };
  if (classList.contains('profiles') && classList.contains('edit')){
    let coverImageLoader = document.getElementById('user_profile_attributes_cover_image');
    let imageLoader = document.getElementById('user_profile_attributes_avatar');
    coverImageLoader.addEventListener('change', function(e) { handleImage(e, 'cover-image-preview', 'user_profile_attributes_cover_image_params', 1140 / 400, )}, false);
    imageLoader.addEventListener('change', function(e) { handleImage(e, 'avatar-preview', 'user_profile_attributes_avatar_params') }, false);
  }
})

function handleImage(e, idName, paramsId, aspectRatio = 1) {
  let reader = new FileReader();
  reader.onload = function (event) {
      $('#' + idName).attr('src',event.target.result);

      if (paramsId){
        let image = document.getElementById(idName);

        if (croppers[idName]){
          croppers[idName].destroy();
        }

        croppers[idName] = new Cropper(image, {
          aspectRatio: aspectRatio,
          viewMode: 2,
          dragMode: 'move',
          rotatable: false,
          scalable: false,
          zoomable: false
        });
        image.addEventListener('crop', function(event){
          document.getElementById(paramsId).value = JSON.stringify(event.detail);
        })
      }
  }
  reader.readAsDataURL(e.target.files[0]);
}
